import dayjs from "dayjs";
import { isNil } from "lodash";

import { NO_DATA_SIGN } from "app/filters/const";

import { USD_SIGN } from "../../../consts";
import type { GraphPoint } from "../../../services/search-overview-api/types";

export const calculatePercentage = (part: number, total: number): number =>
    total > 0 ? Number(((part / total) * 100).toFixed(2)) : 0;

export const parseGraphData = (graph?: GraphPoint[]): number[][] => {
    if (!graph) {
        return [];
    }
    return graph.reduce(
        (acc, cur) => (cur?.Value !== null ? [...acc, [dayjs(cur.Key).valueOf(), cur.Value]] : acc),
        [] as number[][],
    );
};
export const costPerVisitFormatter = (value: number | null): string => {
    return !isNil(value) ? `${USD_SIGN}${value.toFixed(2)}` : NO_DATA_SIGN;
};
